module.exports = __webpack_public_path__ + "static/media/loop.bd84a11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/loop.png
// module id = 2069
// module chunks = 6